<div class="agenda-header">
  <div class="col-infos">
    <span></span>
  </div>
  <ng-container *ngIf="model?.listCalendars[0]?.body?.weeklyRows?.length > 0">
    <div *ngFor="let col of model?.listCalendars[0].body.weeklyRows[0].cols; let i = index; trackBy: trackWeeklyCols" class="col-header col p-0">
      <div class="day-of-week  d-none d-md-block">{{model?.listCalendars[0].body.startDate | DayOfQueovalDate: indParam.AppParams.culture: 'long': i}}</div>
      <div class="day-of-week  d-md-none">{{model?.listCalendars[0].body.startDate | DayOfQueovalDate: indParam.AppParams.culture: 'short': i}}</div>
    </div>
  </ng-container>
</div>

<div class="agenda-body">
  <ng-container *ngIf="model?.listCalendars[0]?.body?.weeklyRows?.length > 0">
    <div *ngFor="let row of model?.listCalendars[0].body.weeklyRows; let iRow = index; trackBy: trackWeeklyRows" class="agenda-row" [style.height.px]="row.height">
      <div class="col-infos">
        <span *ngIf="model?.listCalendars[0]?.body?.WeekNumbers && model?.listCalendars[0]?.body?.WeekNumbers.length > 0" class="info-hour">{{model?.listCalendars[0]?.body?.WeekNumbers[iRow]}}</span>
      </div>
      <div *ngFor="let col of row.cols; let i = index; trackBy: trackWeeklyCols" class="col-body col p-0"
           (click)="OpenModal((iRow * 7 ) + i);"
           (drop)="onDrop($event, (iRow * 7 ) + i)"
           (dragover)="allowDrop($event, i, iRow)"
           [ngClass]="{'drag-over': dragStart && dragRowId === iRow && dragColId === i}"
           [style.background-color]="!col.IsWorkingDay ? '#ccccff' : ''"
           [style.border]="!col.IsWorkingDay ? '1px solid white' : ''">
        <span class="date-of-day"
              [ngClass]="{'current-date': CompareDates((iRow * 7 ) + i)}">
          {{model?.listCalendars[0].body.startDate | NumberOfQueovalDay: (iRow * 7 ) + i}}
        </span>
        <div class="header-events-container">
          <ng-container *ngFor="let event of col.events; trackBy: trackWeeklyEvents">
            <ng-container *ngIf="!event.isAnonimized && event.isMain && event.position < 5">

              <ng-container *ngIf="event.isMultiDay">
                <div class="event position-absolute {{event.clipPath}}"
                     style="border-left:5px solid;padding-left:3px;"
                     [style.border-left-color]="event.borderColor"
                     [style.background-color]="event.color" [style.width]="event.width" [style.top]="event.top"
                     [placement]="iRow <= 1 ? 'bottom' : 'top'"
                     (mouseenter)="contextEvent = event;"
                     (mouseleave)="contextEvent = null"
                     [ngbPopover]="displayPopover ? popContentModale : ''"
                     popoverClass="agenda-affiche"
                     container="body"
                     triggers="mouseenter:mouseleave"
                     (click)="EmitEvent(event)"
                     [ngClass]="{'q-cursor-default': !event.isReadable && !event.isUpdatable}"
                     [draggable]="event?.isUpdatable"
                     (dragover)="DisableDrop($event)"
                     (dragend)="DragEnd();"
                     (dragstart)="dragEvent(event)">
                  {{event.startDate.jour}} {{event.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{startDateYear(event.startDate, event.endDate)}}
                  -
                  {{event.endDate.jour}} {{event.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.endDate.annee}}
                  {{event.label}}
                </div>
              </ng-container>


              <ng-container *ngIf="!event.isMultiDay">
                <div class="event position-absolute {{event.clipPath}}" [style.width]="event.width" [style.top]="event.top"
                      style="border-left:5px solid;padding-left:3px;"
                     [style.border-left-color]="event.borderColor"
                     [style.background-color]="event.color"
                     [placement]="iRow <= 1 ? 'bottom' : 'top'"
                     (mouseenter)="contextEvent = event;"
                     (mouseleave)="contextEvent = null"
                     [ngbPopover]="displayPopover ? popContentModale : ''"
                     popoverClass="agenda-affiche"
                     container="body"
                     triggers="mouseenter:mouseleave"
                     (click)="EmitEvent(event)"
                     [ngClass]="{'q-cursor-default': !event.isReadable && !event.isUpdatable}"
                     [draggable]="event?.isUpdatable"
                     (dragover)="DisableDrop($event)"
                     (dragend)="DragEnd();"
                     (dragstart)="dragEvent(event)">
                  <!--<span class="circle-day mr-1"> </span>-->
                  {{event.startDate.heures}}:{{event.startDate.minutes}}
                  -
                  {{event.endDate.heures}}:{{event.endDate.minutes}}
                  {{event.label}}
                </div>
              </ng-container>

            </ng-container>
            <ng-container *ngIf="event.isAnonimized && event.isMain && event.position < 5">

              <ng-container *ngIf="event.isMultiDay">
                <div class="event position-absolute q-cursor-default {{event.clipPath}}"
                     style="border-left:5px solid;padding-left:3px;"
                     [style.border-left-color]="event.borderColor"
                     [style.background-color]="event.color" [style.width]="event.width" [style.top]="event.top"
                     [placement]="iRow <= 1 ? 'bottom' : 'top'"
                     (mouseenter)="contextEvent = event;"
                     (mouseleave)="contextEvent = null"
                     [ngbPopover]="displayPopover ? popContentModale : ''"
                     popoverClass="agenda-affiche"
                     container="body"
                     triggers="mouseenter:mouseleave">
                  {{event.startDate.jour}} {{event.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{startDateYear(event.startDate, event.endDate)}}
                  -
                  {{event.endDate.jour}} {{event.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.endDate.annee}}
                  Privé
                </div>
              </ng-container>


              <ng-container *ngIf="!event.isMultiDay">
                <div class="event position-absolute q-cursor-default {{event.clipPath}}" [style.width]="event.width" [style.top]="event.top"
                      style="border-left:5px solid;padding-left:3px;"
                     [style.border-left-color]="event.borderColor"
                     [style.background-color]="event.color"
                     [placement]="iRow <= 1 ? 'bottom' : 'top'"
                     (mouseenter)="contextEvent = event;"
                     (mouseleave)="contextEvent = null"
                     [ngbPopover]="displayPopover ? popContentModale : ''"
                     popoverClass="agenda-affiche"
                     container="body"
                     triggers="mouseenter:mouseleave">
                  <!--<span class="circle-day mr-1"> </span>-->
                  {{event.startDate.heures}}:{{event.startDate.minutes}}
                  -
                  {{event.endDate.heures}}:{{event.endDate.minutes}}
                  Privé
                </div>
              </ng-container>

            </ng-container>
          </ng-container>
        </div>
        <span *ngIf="col?.events?.length > 2" class="circle-button" (click)="AfficheAllEvents(content, col?.events, (iRow * 7 ) + i)">{{col?.events?.length}}</span>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h1 style="color: var(--c-main);">
      <span class="mr-2">{{daySelected}}</span>
      <span>{{dayNumberSelected}}</span>
    </h1>

    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true" class="q-c-danger">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngFor="let event of rdvSelected">
      <ng-container *ngIf="!event.isAnonimized">
        <div (click)="EmitEvent(event);" class="modal-event"
             [ngClass]="{'q-cursor-default': !event.isReadable && !event.isUpdatable}"
             placement="top"
             (mouseenter)="contextEvent = event;"
             (mouseleave)="contextEvent = null"
             [ngbPopover]="displayPopover ? popContentModale : ''"
             popoverClass="agenda-affiche"
             container="body"
             triggers="mouseenter:mouseleave"
             style="border-left:5px solid;padding-left:3px;"
             [style.border-left-color]="event.borderColor"
             [style.background-color]="event.color" role="button">
          <!--<div *ngIf="!event.isMultiDay" class="circle-container">
            <div class="circle-colored"></div>
          </div>-->
          <span>
            <span *ngIf="event.isMultiDay">
              {{event.startDate.jour}} {{event.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{startDateYear(event.startDate, event.endDate)}}
              -
              {{event.endDate.jour}} {{event.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.endDate.annee}}
              {{event.label}}
            </span>
            <span *ngIf="!event.isMultiDay">
              {{event.startDate.heures}}:{{event.startDate.minutes}}
              -
              {{event.endDate.heures}}:{{event.endDate.minutes}}
              {{event.label}}
            </span>
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="event.isAnonimized">
        <div class="modal-event q-cursor-default"
             placement="top"
             (mouseenter)="contextEvent = event;"
             (mouseleave)="contextEvent = null"
             [ngbPopover]="displayPopover ? popContentModale : ''"
             popoverClass="agenda-affiche"
             container="body"
             triggers="mouseenter:mouseleave"
             style="border-left:5px solid;padding-left:3px;"
             [style.border-left-color]="event.borderColor"
             [style.background-color]="event.color" role="button">
          <!--<div *ngIf="!event.isMultiDay" class="circle-container">
            <div [style.border-left-color]="event.borderColor" [style.border-color]="event.color" class="circle-colored"></div>
          </div>-->
          <span>
            <span *ngIf="event.isMultiDay">
              {{event.startDate.jour}} {{event.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{startDateYear(event.startDate, event.endDate)}}
              -
              {{event.endDate.jour}} {{event.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{event.endDate.annee}}
              Privé
            </span>
            <span *ngIf="!event.isMultiDay">
              {{event.startDate.heures}}:{{event.startDate.minutes}}
              -
              {{event.endDate.heures}}:{{event.endDate.minutes}}
              Privé
            </span>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>


<ng-template #popContentModale>
  <ng-container *ngIf="contextEvent && !contextEvent?.isAnonimized && contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">{{contextEvent.label}}</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
      </div>
      <div class="q-hour-popover">
        {{contextEvent.endDate.jour}} {{contextEvent.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.endDate.annee}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
    <div class="q-body-popover">
      <div *ngFor="let info of contextEvent.infos" class="w-100">
        <span class="q-c-main">{{info.key}} : </span>
        <span>{{info.value}}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="contextEvent && contextEvent?.isAnonimized && contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">Privé</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
      </div>
      <div class="q-hour-popover">
        {{contextEvent.endDate.jour}} {{contextEvent.endDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.endDate.annee}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="contextEvent && !contextEvent?.isAnonimized && !contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">{{contextEvent.label}}</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
    <div class="q-body-popover">
      <div *ngFor="let info of contextEvent.infos" class="w-100">
        <span class="q-c-main">{{info.key}} : </span>
        <span>{{info.value}}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="contextEvent && contextEvent?.isAnonimized && !contextEvent?.isMultiDay">
    <div class="q-header-popover">
      <div class="q-object-popover">Privé</div>
      <div class="q-hour-popover">
        {{contextEvent.startDate.jour}} {{contextEvent.startDate | MonthOfQueovalDate: indParam.AppParams.culture: 'short'}} {{contextEvent.startDate.annee}}
        -
        {{contextEvent.startDate.heures}}:{{contextEvent.startDate.minutes}}
        -
        {{contextEvent.endDate.heures}}:{{contextEvent.endDate.minutes}}
      </div>
    </div>
  </ng-container>
</ng-template>
